import { render, staticRenderFns } from "./RemandAdvertisementButton.vue?vue&type=template&id=039f79d0&"
import script from "./RemandAdvertisementButton.vue?vue&type=script&lang=ts&"
export * from "./RemandAdvertisementButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports